(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Scroll reveal ---- */
  if (!reduceMotion) {
    document.documentElement.classList.add('mv-js');

    const sections = document.querySelectorAll('#MainContent > .shopify-section');
    const targets = [];

    sections.forEach((sec, index) => {
      if (index === 0) return;
      if (sec.querySelector('marquee-component')) return;
      if (sec.querySelector('.mv-sticky-cart')) return;
      sec.setAttribute('data-mv-reveal', 'up');
      targets.push(sec);
    });

    if (!('IntersectionObserver' in window)) {
      targets.forEach((sec) => sec.classList.add('mv-in'));
    } else {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('mv-in');
            io.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.06 }
      );

      targets.forEach((sec) => {
        const cards = sec.querySelectorAll('product-card, .product-card');
        cards.forEach((card, i) => {
          card.style.setProperty('--mv-delay', `${Math.min(i * 70, 420)}ms`);
        });
        io.observe(sec);
      });
    }
  }

  /* ---- Sticky mobile cart bar ---- */
  const stickyBar = document.querySelector('.mv-sticky-cart');
  if (stickyBar) {
    let ticking = false;
    const update = () => {
      const visible = window.scrollY > 480;
      stickyBar.classList.toggle('mv-show', visible);
      stickyBar.setAttribute('aria-hidden', String(!visible));
      ticking = false;
    };
    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(update);
        }
      },
      { passive: true }
    );
    update();
  }
})();
